<template>
  <div>
    <bd-table-list
      :breadcrumb="breadcrumb"
      ref="resource"
      title="Créanciers dont des mandats ne sont pas utilisés depuis plus d'un an"
      subtitle="Recherche de créanciers"
      autocomplete_idHistory="creditors"
      autocomplete_field="creancier.nom_soc || creancier.nom || creancier.prenom"
      bdTable="mandat_unused"
      :actions="actions"
      :fields="fields"
      :Api="Api"
    >
    <template v-slot:cell(creancierID)="data">
        <b-link
          :to="{ name: 'creditorView', params: { id: data.item.creancierID } }"
        >
          {{ data.item.creancierID }}
        </b-link>
      </template>
      <template v-slot:cell(nom_soc)="data">
        <b-link
          :to="{ name: 'creditorView', params: { id: data.item.creancierID } }"
        >
          {{ completeName(data.item) }}
        </b-link>
      </template>
    </bd-table-list>
  </div>
</template>

<script>
import BdTableList from "@/components/BdTableList";
import String from "@/services/String.js";
import DateTime from "@/services/DateTime.js";
import gestion from "@/services/gestion.js";
export default {
  name: "ManageUnused",
  components: {
    BdTableList,
  },
  data() {
    return {
      Api: gestion.unused,
      breadcrumb: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Créanciers ayant des mandats inutilisés depuis plus d'un an",
          active: true,
        },
      ],
      actions: [
        {
          label: "Éditer",
          to: "warrantEdit",
        },
      ],
      fields: [
        {
          key: "creancierID",
          label: "#",
          sortable: true,
          class: "text-right",
          thStyle: {width: '100px'},
        },

        {
          key: "nom_soc",
          label: "Créancier",
          sortable: true,
          class: "text-truncate",
        },
        {
          key: "date",
          label: "Date du carnet",
          sortable: true,
          formatter: (value) => this.toDate(value),
          thStyle: {width: '100px'},
        },
        {
          key: "num_unused",
          label: "Mandats unitilisés",
          formatter: (value, key, item) => {
            return item.num_unused + ' / ' + item.num_total
          }
        }
      ],
    };
  },
  methods: {
    completeName(item) {
      let a = "";
      if (item.nom_soc) {
        a += item.nom_soc;
      }
      if (item.nom && item.nom_soc) {
        a += " (" + item.prenom + " " + item.nom + ")";
      } else if (!item.nom_soc) {
        a += item.prenom + " " + item.nom;
      }
      return a;
    },
    company(str) {
      return String.company(str);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>